import { MatDialog } from "@angular/material/dialog";
import { Observable, of } from "rxjs";
import { DialogComponent } from "../dialog/dialog.component";

export class FileNode {
	id: string;
	children: FileNode[];
	name: string;
	idDataSource: number;
	idNode: number;
	canMakeDragDrop: boolean;
}

export class FileFlatNode {
	constructor(
		public expandable: boolean,
		public name: string,
		public level: number,
		public idDataSource: number,
		public idNode: number,
		public id: string,
		public canMakeDragDrop: boolean
	) {}
}

export class DataNode {
	public canSave: boolean;
	public nodeToMove: FileFlatNode;
	public nodeInDrag: any;
}

export class TreeDragDropAuxComponent {
	constructor(protected dialog: MatDialog) {}
	protected transformer = (node: FileNode, level: number) => {
		return new FileFlatNode(
			!!node.children && node.children.length > 0,
			node.name,
			level,
			node.idDataSource,
			node.idNode,
			node.id,
			node.canMakeDragDrop
		);
	};

	protected _getLevel = (node: FileFlatNode) => node.level;
	protected _isExpandable = (node: FileFlatNode) => node.expandable;
	protected _getChildren = (node: FileNode): Observable<FileNode[]> => of(node.children);
	protected _getId = (node: FileNode) => node.id;

	public hasChild = (_: number, _nodeData: FileFlatNode) => _nodeData.expandable;

	protected canMoveNode(nodeToMove: FileFlatNode, nodeInDrag: FileFlatNode): boolean {
		if (nodeInDrag.idNode === 3) {
			if (nodeToMove.idNode === 2) {
				return true;
			} else {
				this.showModal(`O ${nodeInDrag.name} deve ficar abaixo da diretoria. por favor tente novamente!`);
				return false;
			}
		} else if (nodeInDrag.idNode === 4) {
			if (nodeToMove.idNode === 2 || nodeToMove.idNode === 3 || nodeToMove.idNode === 4) {
				return true;
			} else {
				this.showModal(
					`A ${nodeInDrag.name} deve ficar abaixo do gerente comercial ou de um diretor. por favor tente novamente!`
				);
				return false;
			}
		} else if (nodeInDrag.idNode === 5) {
			if (nodeToMove.idNode === 4) {
				return true;
			} else {
				this.showModal(`O ${nodeInDrag.name} deve ficar abaixo da corretora. por favor tente novamente!`);
				return false;
			}
		}

		return true;
	}

	private showModal(text = ""): void {
		const dialogRef = this.dialog.open(DialogComponent, {
			data: { title: "Atenção", text },
			height: "238px",
			width: "480px",
			disableClose: true
		});
		dialogRef.componentInstance.secondNameButton = "ENTENDI";
	}
}
